import { LoginLink } from "~/components/LoginLink";
import { Body, Button, Card, Headline, Icon } from "~/ui-library";
import { ArrowLeftIcon } from "~/ui-library/icons";
import {
  RegisterAccountForm,
  RegisterAccountFormFields,
} from "~/components/RegisterAccountForm";

export type SubCheckoutCreateYourAccountFormProps = {
  onBackClick?: () => void;
  onFormSubmit: (formValues: RegisterAccountFormFields) => void;
  postLoginRedirect: string;
};

export const SubCheckoutCreateYourAccountForm: React.FC<
  SubCheckoutCreateYourAccountFormProps
> = ({ onBackClick, onFormSubmit, postLoginRedirect }) => (
  <Card className="px-m py-s" elevation={0}>
    <Headline level={4} className="mb-xs">
      Sign in or Create an Account
    </Headline>
    <div className="mb-s">
      <Body size="small" className="mb-xxs md:mb-0">
        Already have a Morning Consult Account?{" "}
        <LoginLink
          behavior={{ type: "window" }}
          className="xs:text-body-small xs:leading-body"
        >
          Sign in
        </LoginLink>
      </Body>
    </div>

    <Card className="p-m" elevation={0}>
      <Button
        className="mb-s"
        data-testid="back-button"
        onClick={onBackClick}
        size="extraSmall"
        variant="link"
      >
        <Icon className="mr-xxs" size="small" SvgIcon={ArrowLeftIcon} />
        Back
      </Button>

      <RegisterAccountForm
        onSubmit={onFormSubmit}
        postLoginRedirect={postLoginRedirect}
      />
    </Card>
  </Card>
);
